import React from 'react'
import {
  IconTrash,
  IconFileTypeDoc,
  IconFileTypeXls,
  IconFileTypePdf,
} from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function FileDocuments() {

  const fileDocumentList = [
    {
      icon: IconFileTypeDoc,
      name: "Document_2017.doc",
      type: "doc",
      size: "42KB",
      date: "Nov 02, 2017",
    },
    {
      icon: IconFileTypeDoc,
      name: "Document_2017.doc",
      type: "doc",
      size: "89KB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconFileTypeDoc,
      name: "Document_2017.doc",
      type: "doc",
      size: "89KB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconFileTypeXls,
      name: "Report2016.xls",
      type: "xls",
      size: "68KB",
      date: "Dec 12, 2016",
    },
    {
      icon: IconFileTypeXls,
      name: "Report2016.xls",
      type: "xls",
      size: "68KB",
      date: "Dec 12, 2016",
    },
    {
      icon: IconFileTypePdf,
      name: "Sample2016.pdf",
      type: "pdf",
      size: "3MB",
      date: "Aug 18, 2017",
    },
    {
      icon: IconFileTypePdf,
      name: "Sample2016.pdf",
      type: "pdf",
      size: "3MB",
      date: "Aug 18, 2017",
    },
    {
      icon: IconFileTypePdf,
      name: "Sample2016.pdf",
      type: "pdf",
      size: "3MB",
      date: "Aug 18, 2017",
    },
    {
      icon: IconFileTypePdf,
      name: "Sample2016.pdf",
      type: "pdf",
      size: "3MB",
      date: "Aug 18, 2017",
    },
    {
      icon: IconFileTypeXls,
      name: "Report2016.xls",
      type: "xls",
      size: "68KB",
      date: "Dec 12, 2016",
    },
    {
      icon: IconFileTypeXls,
      name: "Report2016.xls",
      type: "xls",
      size: "68KB",
      date: "Dec 12, 2016",
    },
    {
      icon: IconFileTypeXls,
      name: "Report2016.xls",
      type: "xls",
      size: "68KB",
      date: "Dec 12, 2016",
    },
    {
      icon: IconFileTypeDoc,
      name: "Document_2017.doc",
      type: "doc",
      size: "89KB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconFileTypeDoc,
      name: "Document_2017.doc",
      type: "doc",
      size: "89KB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconFileTypeXls,
      name: "Report2016.xls",
      type: "xls",
      size: "68KB",
      date: "Dec 12, 2016",
    },
    {
      icon: IconFileTypeDoc,
      name: "Document_2017.doc",
      type: "doc",
      size: "89KB",
      date: "Dec 15, 2017",
    },
  ]

  return (
    <>
      <Breadcrumb title="File Documents" path="File Manager / File Documents" />
      <div className='grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 lg:gap-30 gap-15'>
        {fileDocumentList.map((item, key) => (
          <Link to="#" key={key} className='bg-bg-dark shadow-light rounded-lg relative group'>
            <div className='py-15 px-10 min-h-[130px] flex items-center justify-center'>
              <item.icon
                className={`w-[40px] h-[40px] stroke-[1.5] ${item.type === 'doc' ? 'text-blue' : item.type === 'xls' ? 'text-success' : item.type === 'pdf' ? 'text-danger' : ''}`}
              />
            </div>
            <div className='border-t border-border p-10'>
              <p className="mb-5 text-text-primary">{item.name}</p>
              <small className='text-blue flex items-center justify-between gap-10'>
                Size: {item.size}
                <span className="text-text-secondary">{item.date}</span>
              </small>
            </div>
            <button className='bg-danger rounded-[4px] px-10 py-[8px] absolute right-10 top-10 z-[1] hidden group-hover:block'>
              <IconTrash className='text-white w-[18px] h-[18px] stroke-[1.5]' />
            </button>
          </Link>
        ))}
      </div>
    </>
  )
}
